'use client'

import type { FC, PropsWithChildren } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
library.add(fab, fal, far, fas)

export const FontAwesomeLibraryClient: FC<PropsWithChildren> = ({ children }) => {
	return <>{children}</>
}
